import { useScreenType } from '@/hooks/media';
import classNames from 'classnames';

export function Block(props: {
  className?: string;
  title?: string;
  children?: React.ReactNode;
}) {
  const { isMobile } = useScreenType();

  return (
    <div className={`section-block ${props.className}`}>
      {props.title && (
        <h1
          className={classNames([
            'font-semibold',
            isMobile ? 'text-lg mb-4' : 'text-3hxl  md:mb-6',
          ])}
        >
          {props.title}
        </h1>
      )}
      {props.children}
    </div>
  );
}
